module.exports = __webpack_public_path__ + "img/info.c5a2a936.svg";